<template>
    <div class="nameSlug mb-3">
        <div class="form-group">
            <label :for="idName">{{ labelName }}</label>
            <input type="text" class="form-control" :placeholder="labelName" :name="nameName" :id="idName" v-model="name" @focus="!checked ? clearMessage() : null" @blur="generateSlugFromName()" @keyup="updateSlug()"/>
            <div class="d-block invalid-feedback" v-if="errorName">{{ errorName }}</div>
        </div>
        <div class="form-group">
            <label  :for="idSlug">{{ labelSlug }}</label><br>
            <input type="text" :class="[errSlug ? 'is-invalid': '', 'form-control']" :placeholder="labelSlug" :name="nameSlug" :id="idSlug" v-model="slug" :readonly="!checked"  @focus="clearMessage()" @blur="generateSlugFromSlug()"/>
            <div class="d-block invalid-feedback" v-if="errSlug">{{ errSlug }}</div>
            <div class="text-info" v-if="message">{{ message }}</div>
        </div>
        <div class="form-check form-check-inline">
            <input class="form-check-input" type="checkbox" :name="nameCheckbox" :id="idCheckbox" value="1"  v-model="checked" @click="clearMessage()">
            <label class="form-check-label" :for="idCheckbox">{{ labelCheckbox }}</label>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        labelName: String,
        nameName: String,
        idName: String,
        valueName: String,
        errorName: String,

        labelSlug: String,
        nameSlug: String,
        idSlug: String,
        valueSlug: String,
        errorSlug: String,
        messageSlug: String,

        labelCheckbox: String,
        nameCheckbox: String,
        idCheckbox:String,
        valueCheckbox: Boolean,

        abbreviation: String,
        idModel: String,

    },
    data() {
        return {
            checked: this.valueCheckbox,
            name: this.valueName,
            slug: this.valueSlug,
            errSlug: this.errorSlug,
            message: '',
        }
    },
    methods: {
        updateSlug() {
            if(!this.checked) {
                this.slug = this.name.split(' ').join('-').toLowerCase();
            }
        },
        generateSlugFromName() {
            if(!this.checked) {
                this.fetchSlug(this.name);
            }
        },
        generateSlugFromSlug(){
            this.fetchSlug(this.slug);
        },
        fetchSlug(slug){
            axios
                .post("/"+this.abbreviation+"/admin/sites/slug", {
                    id: this.idModel,
                    name: slug
                })
                    .then(response => {
                        this.slug = response.data.slug;
                        if(response.data.index > 0) {
                            this.message = this.messageSlug;
                        }
                    }).catch((error) => {
                        console.log(error);
                    });
        },
        clearMessage(){
            this.message='';
            this.errSlug='';
        },
    },
    watch: {
        checked(newValue) {
            if(!newValue) {
                this.fetchSlug(this.name);
            }
        }
    }
}
</script>
